var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "view", staticClass: "shadow-dk", attrs: { id: "overlays" } },
    [
      _c("div", { staticClass: "mini-left-col category" }, [
        _c("div", { staticClass: "legend-header" }, [
          _vm._v("\n\t\t\tOVERLAYS\n\t\t")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "legend-list" },
          _vm._l(_vm.categories, function(row, index) {
            return _c("div", { key: row.label, staticClass: "legend-row" }, [
              _c("span", {
                staticClass: "legend-swatch",
                style: _vm.swatchStyle(row)
              }),
              _vm._v(" "),
              _c("span", { staticClass: "legend-label" }, [
                _vm._v("\n\t\t\t\t\t" + _vm._s(row.label) + "\n\t\t\t\t")
              ])
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51856b2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51856b2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overlay/overlay-list.vue
// module id = null
// module chunks = 